/**
 * Created by razial on 15.04.2026.
 */

const RewardedPromoConfig = {
    TRY_WINDOW_TIMEOUT: cleverapps.parseInterval("3 day"),

    // a promotion runs until its schedule event finishes and is not started with less than MIN_REMAINING left
    MIN_REMAINING: cleverapps.parseInterval("2 week"),

    PROJECTS: {}
};

RewardedPromoConfig.PROJECTS.garden = {
    bundle: "rewarded_promo_garden",
    sidebarIcon: "rewarded_promo_icon_garden_json",
    feature: "rewarded_promo_garden",
    // the window itself is in each source game's res/schedule.json, feature "rewarded_promo_garden"
    sources: ["mergecraft", "woodenblock"],
    tasks: [{
        bit: 0,
        title: { text: "RewardedPromo.launch_game.title" },
        icon: "task0_icon"
    }, {
        bit: 1,
        title: { text: "RewardedPromo.make_first_order.title" },
        icon: "task1_icon",
        conditions: { completedOrders: 1 }
    }, {
        bit: 2,
        title: { text: "RewardedPromo.reach_level.title", toReplace: { level: 3 } },
        icon: "task2_icon",
        conditions: { actualLevel: 3 }
    }, {
        bit: 3,
        title: { text: "RewardedPromo.complete_orders.title", toReplace: { orders: 50 } },
        icon: "task3_icon",
        conditions: { completedOrders: 50 }
    }, {
        bit: 4,
        title: { text: "RewardedPromo.reach_level.title", toReplace: { level: 10 } },
        icon: "task2_icon",
        conditions: { actualLevel: 10 }
    }, {
        bit: 5,
        title: { text: "RewardedPromo.complete_orders.title", toReplace: { orders: 150 } },
        icon: "task3_icon",
        conditions: { completedOrders: 150 }
    }, {
        bit: 6,
        title: { text: "RewardedPromo.reach_level.title", toReplace: { level: 20 } },
        icon: "task2_icon",
        conditions: { actualLevel: 20 }
    }, {
        bit: 7,
        title: { text: "RewardedPromo.complete_all.title" },
        icon: "task0_icon"
    }]
};

RewardedPromoConfig.PROJECTS.ladacha = {
    bundle: "rewarded_promo_ladacha",
    sidebarIcon: "rewarded_promo_icon_ladacha_json",
    feature: "rewarded_promo_ladacha",
    // the window itself is in each source game's res/schedule.json, feature "rewarded_promo_ladacha"
    sources: ["fairy", "wondermerge"],
    tasks: [{
        bit: 0,
        title: { text: "RewardedPromo.launch_game.title" },
        icon: "task0_icon"
    }, {
        bit: 1,
        title: { text: "RewardedPromo.make_first_order.title" },
        icon: "task1_icon",
        conditions: { completedOrders: 1 }
    }, {
        bit: 2,
        title: { text: "RewardedPromo.reach_level.title", toReplace: { level: 3 } },
        icon: "task2_icon",
        conditions: { actualLevel: 3 }
    }, {
        bit: 3,
        title: { text: "RewardedPromo.complete_orders.title", toReplace: { orders: 50 } },
        icon: "task3_icon",
        conditions: { completedOrders: 50 }
    }, {
        bit: 4,
        title: { text: "RewardedPromo.reach_level.title", toReplace: { level: 10 } },
        icon: "task2_icon",
        conditions: { actualLevel: 10 }
    }, {
        bit: 5,
        title: { text: "RewardedPromo.complete_orders.title", toReplace: { orders: 150 } },
        icon: "task3_icon",
        conditions: { completedOrders: 150 }
    }, {
        bit: 6,
        title: { text: "RewardedPromo.reach_level.title", toReplace: { level: 20 } },
        icon: "task2_icon",
        conditions: { actualLevel: 20 }
    }, {
        bit: 7,
        title: { text: "RewardedPromo.complete_all.title" },
        icon: "task0_icon"
    }]
};
